import template from './_confirm.pug'

// @vue/component
export default {
  template: template(),
  methods: {
    onDeregister() {
      this.$emit('deregister')
    },
    cancel() {
      this.$emit('deregister-finished')
    }
  }
}
